import React from 'react';

export default function SimpleBrandingForecast() {
  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px' }}>Branding Forecast</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f3f4f6' }}>
            <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>Platform</th>
            <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>Campaign Type</th>
            <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>Impressions</th>
            <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>CPM (₺)</th>
            <th style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>Cost (₺)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>Google Ads</td>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>Display</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>281,690</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺71.00</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺20,000</td>
          </tr>
          <tr>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>Google Ads</td>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>YouTube Video</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>10,000,000</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺20.00</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺200,000</td>
          </tr>
          <tr>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>Meta Ads</td>
            <td style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>Engagement</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>1,046,436</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺30.58</td>
            <td style={{ padding: '8px', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>₺32,000</td>
          </tr>
          <tr style={{ backgroundColor: '#f3f4f6', fontWeight: 'bold' }}>
            <td style={{ padding: '8px' }} colSpan="2">TOTAL</td>
            <td style={{ padding: '8px', textAlign: 'right' }}>11,328,126</td>
            <td style={{ padding: '8px', textAlign: 'right' }}>-</td>
            <td style={{ padding: '8px', textAlign: 'right' }}>₺252,000</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
} 